module.exports = __webpack_public_path__ + "img/pr-2.a0827abd.png";